import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Nav from './components/Nav';
import HeroVideo from './components/HeroVideo';
import PinnedReveal from './components/PinnedReveal';
import PlatformPillars from './components/PlatformPillars';
import Courses from './components/Courses';
import Marquee from './components/Marquee';
import Audience from './components/Audience';
import StatsBand from './components/StatsBand';
import SignUpForm from './components/SignUpForm';
import Footer from './components/Footer';

function Home() {
  return (
    <div className="bg-black text-white min-h-screen">
      <Nav />
      <HeroVideo />
      <PinnedReveal />
      <PlatformPillars />
      <Courses />
      <Marquee />
      <Audience />
      <StatsBand />
      <SignUpForm />
      <Footer />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
